import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { TicketsDataService } from '../../Services/TicketsDataService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons';
import './AllTicketsPage.scss';
import Table from '../../Components/Table/Table';
import { PageLayout2 } from '../../Components/PageLayout/PageLayout2';
import { InteractionType } from '@azure/msal-browser';
import { formatGuatemalanDateTime } from '../../Utils/dateFormat';

const AllTicketsContent = () => {
    const { instance, accounts } = useMsal();
    const [requests, setRequests] = useState([]);

    useEffect(() => {
        fetchOpenRequests();
    }, []);

    const fetchOpenRequests = async () => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);
            const data = await TicketsDataService.getAllTickets(response.accessToken); // Assuming you have an API method for this
            setRequests(data);
        } catch (error) {
            console.error('Failed to fetch open requests:', error);
        }
    };

    const columns = [
        {
            header: 'Inbox',
            accessorKey: 'isRead',
            cell: ({ row }) => (
                <div className="text-center">
                    <FontAwesomeIcon icon={row.original.isRead ? faEnvelopeOpen : faEnvelope} />
                </div>
            )
        },
        { header: 'ID', accessorKey: 'id' },
        { header: 'Subject', accessorKey: 'subject' },
        { header: 'Requester', accessorKey: 'requesterEmail' },
        { header: 'Organization', accessorKey: 'organization' },
        { header: 'Assigned', accessorKey: 'assignedTo' },
        { header: 'Type', accessorKey: 'typeOfHelp' },
        { header: 'Opened', accessorKey: 'creationDate', cell: info => formatGuatemalanDateTime(info.getValue()) },
        { header: 'Updated', accessorKey: 'updatedDate', cell: info => formatGuatemalanDateTime(info.getValue()) },
        { header: 'Days Opened', accessorKey: 'daysOpened' },
        { header: 'Files', accessorKey: 'filesCount' },
        {
            header: 'Status',
            accessorKey: 'status',
            cell: ({ row }) => (
                <Badge pill className={`badge-${row.original.status.toLowerCase()}`}>
                    {row.original.status}
                </Badge>
            )
        }
    ];

    return (
        <Container fluid className='open-requests-page h-100 d-flex flex-column'>
            <h5 className="my-4">Open Requests</h5>
            <Row className='flex-1'>
                <Col>
                    <div className='table-container'>
                        <Table columns={columns} data={requests} tableClass="table-sm" containerClass="table-responsive" headerClass="table-light" />
                    </div>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col>
                    <div className="legend-container">
                        <div className="legend-item">
                            <FontAwesomeIcon icon={faEnvelope} /> Unread ticket
                        </div>
                        <div className="legend-item">
                            <FontAwesomeIcon icon={faEnvelopeOpen} /> Viewed ticket
                        </div>
                        <div className="legend-item">
                            <Badge pill bg='warning' className="badge-pending me-2">Pending</Badge> Ticket is pending on the Retail Side
                        </div>
                        <div className="legend-item">
                            <Badge pill bg='success' className="badge-waiting me-2">Waiting</Badge> Ticket is waiting for action on requestor's end
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

const AllTicketsPage = () => {
    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <PageLayout2 title="Support Tickets">
                <AllTicketsContent />
            </PageLayout2>
        </MsalAuthenticationTemplate>
    );
};

export default AllTicketsPage;
